import { LogLevel, PublicClientApplication, type Configuration } from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_AZURE_TENANT_ID as string | undefined;
const clientId = import.meta.env.VITE_AZURE_CLIENT_ID as string | undefined;
const apiScope = import.meta.env.VITE_API_SCOPE as string | undefined;

if (!tenantId || !clientId || !apiScope) {
  // Surface configuration gaps loudly during local boot rather than failing mid-flow at login.
  console.warn(
    '[auth] MSAL is not fully configured. Set VITE_AZURE_TENANT_ID, VITE_AZURE_CLIENT_ID, and VITE_API_SCOPE in client/.env.local.',
    { tenantId, clientId, apiScope },
  );
}

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId ?? '00000000-0000-0000-0000-000000000000',
    authority: `https://login.microsoftonline.com/${tenantId ?? 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) console.error('[msal]', message);
      },
    },
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', apiScope ?? ''].filter(Boolean),
  // Always ask which account to use. Without this, Entra silently reuses whichever
  // browser session it considers current, so anyone signed in to several Microsoft
  // accounts gets authenticated as the wrong one — the redirect succeeds, the API
  // then rejects the token, and the app lands back on the sign-in screen.
  prompt: 'select_account',
};

export const apiTokenRequest = {
  scopes: [apiScope ?? ''].filter(Boolean),
};

// Graph delegated scopes used for the assignment-dropdown lookups.
// Acquired separately from the API token because they target the Graph resource.
export const graphTokenRequest = {
  scopes: [
    'https://graph.microsoft.com/Group.Read.All',
    'https://graph.microsoft.com/GroupMember.Read.All',
    'https://graph.microsoft.com/User.Read.All',
  ],
};

export const msalInstance = new PublicClientApplication(msalConfig);
